import componentHelpers from '@/library/ComponentHelpers';
import VueResource from 'vue-resource';
import Modal from '@/library/Modal';
import Shards from 'shards-vue';
import Vue from 'vue';

// Core.
import router from '@/router';
import i18n from './i18n';
import App from '@/App.vue';

// Styles.
import 'bootstrap/dist/css/bootstrap.css';
import '@/assets/scss/main.scss';

Shards.install(Vue);

// Components.
import FormGroup from '@/components/common/form/FormGroup.vue';
import RooshButton from '@/components/common/RooshButton.vue';
import Loader from '@/components/common/Loader.vue';

Vue.component('r-button', RooshButton);
Vue.component('form-group', FormGroup);
Vue.component('loader', Loader);

Vue.config.productionTip = false;

Vue.use(componentHelpers);
Vue.use(VueResource);
Vue.use(Modal);

new Vue({
  router,
  i18n,

  render: createElement => createElement(App)
}).$mount('#app');
